export default __webpack_public_path__ + "static/media/computer-img.2cb6f9f3.png";